import React from 'react';
import { giaoDichSearchColumns, loSearchColumns, viTriSearchColumns } from '@/constants';
import { RadixHoverDropdown, FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface OtherTabProps {
  searchFieldStates?: MuaHangRecord;
}

const OtherTab: React.FC<OtherTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-4 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã giao dịch:</Label>
          <SearchField
            searchEndpoint={`/`}
            searchColumns={giaoDichSearchColumns}
            dialogTitle='Giao dịch'
            columnDisplay='transactionCode'
            displayRelatedField='transactionName'
            value={searchFieldStates?.transaction?.transactionCode || ''}
            relatedFieldValue={searchFieldStates?.transaction?.transactionName || ''}
            className='w-fit'
            onRowSelection={(row: MuaHangRecord) => {
              searchFieldStates?.setTransaction(row);
            }}
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã lô:</Label>
          <SearchField
            searchEndpoint={`/${QUERY_KEYS.LO}/`}
            searchColumns={loSearchColumns}
            dialogTitle='Lô hàng'
            columnDisplay='ma_lo'
            displayRelatedField='ten_lo'
            value={searchFieldStates?.lot?.ma_lo || ''}
            relatedFieldValue={searchFieldStates?.lot?.ten_lo || ''}
            onRowSelection={(row: MuaHangRecord) => {
              searchFieldStates?.setLot(row);
            }}
            className='w-fit'
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã vị trí:</Label>
          <SearchField
            searchEndpoint={`/${QUERY_KEYS.VI_TRI}/`}
            searchColumns={viTriSearchColumns}
            dialogTitle='Vị trí'
            columnDisplay='locationCode'
            displayRelatedField='locationName'
            value={searchFieldStates?.location?.locationCode || ''}
            relatedFieldValue={searchFieldStates?.location?.locationName || ''}
            onRowSelection={(row: MuaHangRecord) => {
              searchFieldStates?.setLocation(row);
            }}
            className='w-fit'
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Diễn giải:</Label>
          <div className='w-3/4'>
            <FormField name='dien_giai' type='text' className='w-full' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu lọc báo cáo:</Label>
          <div className='w-full'>
            <div className='flex items-center gap-1'>
              <div className='w-64'>
                <FormField
                  name='report_filtering'
                  type='select'
                  options={[{ value: 'user_filter', label: 'Người dùng tự lọc' }]}
                  className='w-full'
                />
              </div>

              <div className='h-9 w-9 flex-shrink-0'>
                <RadixHoverDropdown iconNumber={624} items={[]} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Save Filter Template Dialog */}
    </div>
  );
};

export default OtherTab;
